module.exports = __webpack_public_path__ + "static/hifilabs-c4b7c3ae3419543e9a76887a01270c3d.png";